import { axiosPost, axiosPut, axiosGet } from "../../utilities/axiosRequest"
import {
    lookupsURL,
    appointmentURL,
    putAppointmentStatus,
    sendAppointmentPaymentLinkURL,
    getAppointmentPaymentDetailsURL,
    updateAppointmentPaymentsURL,
    sendAppointmentLink,
    insertReceiptUrl,
    updateReceiptUrl,
    getUserAppointmentTypeUrl,
} from "../../apiEndPoints"
import {
    updateAptStatus,
    updateAppointmentList,
    updateAppointmentsLoading,
    showAppointmentListing,
} from "./appointmentSlice"
import { logTransaction } from "../appActions"
import { getAppointments } from "../../apiEndPoints"
import moment from "moment"
import { schedulerInstance } from "../../utilities/axios"

export function fetchAptStatus() {
    return function (dispatch, getState) {
        let url = lookupsURL + `?lookupCategoryId=${10049}`

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    let array = response.data.responseData.filter(l => l.status)
                    dispatch(updateAptStatus(array))
                }
                dispatch(logTransaction("Fetch appointment status", response))
            })
            .catch(err => {
                dispatch(logTransaction("Fetch appointment status", err))
            })
    }
}

export function fetchAptById(id, success, failure) {
    return function (dispatch, getState) {
        // dispatch(updateAppointmentsLoading(true));
        // dispatch(updateAppointmentList([]));
        let url = appointmentURL + "?"
        if (id !== null && id !== undefined) {
            url = url + `id=${id}`
        }

        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD == 200 &&
                    response.data.responseData.length > 0
                ) {
                    success(response.data.responseData || [])
                    dispatch(updateAppointmentList(response.data.responseData))
                    console.log("response", response.data.responseData)
                }
                // dispatch(updateAppointmentsLoading(false));
            })
            .catch(err => {
                failure(err)
                // dispatch(updateAppointmentsLoading(false));
            })
    }
}

export function AppointmentListing() {
    return function (dispatch, getState) {
        const currentDate = moment()
        const startDateOfMonth = currentDate
            .clone()
            .startOf("month")
            .format("YYYY-MM-DD")
        const endDateOfMonth = currentDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD")
        //let url = getAppointments+`?userId={}&startDate=${startDateOfMonth}&endDate=${endDateOfMonth}`
        let userProfileid = Object.keys(getState().login.user.userProfile)[0]
        // let url = getAppointments + `?users=${userProfileid}&startDate=${startDateOfMonth}&endDate=${endDateOfMonth}`
        let url = getAppointments + `?users=${userProfileid}`
        axiosGet(url)
            .then(response => {
                console.log(response, "nghjghjghj")
                if (
                    response.data.responseData !== null &&
                    response.data.responseData.length > 0
                ) {
                    dispatch(showAppointmentListing(response.data.responseData))
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    dispatch(showAppointmentListing([]))
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                dispatch(showAppointmentListing([]))
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function getAppointmentDetailById(
    id,
    success = () => {},
    failure = () => {},
    clinicId,
    orgId
) {
    return function (dispatch, getState) {
        let url =
            getAppointments + `?id=${id}&clinicId=${clinicId}&orgId=${orgId}`
        axiosGet(url)
            .then(response => {
                if (
                    response.data.responseData !== null &&
                    response.data.responseData
                ) {
                    console.log(response.data.responseData, "sklfjdslfjsld")
                    success(response.data.responseData[0])
                } else {
                    console.log(response.data.statusMSG, "sklfjdslfjsld")
                    failure(response.data.statusMSG)
                }
            })
            .catch(err => {
                console.log(err, "sklfjdslfjsld")
                failure(err.message)
            })
    }
}

export function cancelAppointment(data, success, failure) {
    return function (dispatch, getState) {
        let url = `${putAppointmentStatus}/${data.id}`
        console.log(data, "hufehiueyrf")
        axiosPut(url, { ...data, appointmentStatus: 100490004 })
            .then(response => {
                console.log(response, "nghjghjghj")
                if (response.data.statusCD === 200) {
                    success()
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function sendAppointmentPaymentLink(appointmentId, success, failure) {
    return function (dispatch, getState) {
        let url = `${sendAppointmentPaymentLinkURL}?appointmentId=${appointmentId} `
        axiosPost(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.statusMSG)
                    dispatch(
                        logTransaction("Fetch Performace Report", response)
                    )
                } else {
                    failure()
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function getAppointmentPaymentDetails(appointmentId, success, failure) {
    return function (dispatch, getState) {
        let url = `${getAppointmentPaymentDetailsURL}/${appointmentId} `
        axiosGet(url)
            .then(response => {
                if (
                    response.data.statusCD === 200 &&
                    response.data.responseData
                ) {
                    success(response.data.responseData)
                    // dispatch(logTransaction("Fetch Performace Report", response))
                } else {
                    failure(response.data.statusMSG)
                    dispatch(
                        logTransaction(
                            "Fetch Performace Report Failed",
                            response
                        )
                    )
                }
            })
            .catch(err => {
                failure(err.message)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function updateAppointmentPayments(data, success, failure) {
    return function (dispatch, getState) {
        let url = `${updateAppointmentPaymentsURL}`
        axiosPut(url, data)
            .then(response => {
                // if (
                //   response.data.statusCD === 200 && response.data.responseData
                // ) {
                //   success(response.data.responseData)
                //   // dispatch(logTransaction("Fetch Performace Report", response))
                // } else {
                //   failure(response.data.statusMSG)
                //   dispatch(logTransaction("Fetch Performace Report Failed", response))
                // }
                success()
            })
            .catch(err => {
                failure(err.message)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function sendAppointmentLinkSms(data, success, failure) {
    return function (dispatch, getState) {
        let url = `${sendAppointmentLink}?appointmentId=${data.id}`
        schedulerInstance({
            method: "GET",
            url: url,
        })
            .then(response => {
                // if (
                //   response.data.statusCD === 200 && response.data.responseData
                // ) {
                //   success(response.data.responseData)
                //   // dispatch(logTransaction("Fetch Performace Report", response))
                // } else {
                //   failure(response.data.statusMSG)
                //   dispatch(logTransaction("Fetch Performace Report Failed", response))
                // }
                success()
            })
            .catch(err => {
                failure(err.message)
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function insertReceipt(data, success, failure) {
    return function (dispatch, getState) {
        let url = `${insertReceiptUrl}`
        axiosPost(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.statusMSG)
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("Fetch Performace Report Failed", err))
            })
    }
}

export function updateReceipt(receiptId, data, success, failure) {
    return function (dispatch, getState) {
        let url = `${updateReceiptUrl}`
        axiosPut(url, JSON.stringify(data))
            .then(response => {
                if (response.data.statusCD === 200) {
                    success()
                } else {
                    failure()
                }
            })
            .catch(err => {
                failure()
                dispatch(logTransaction("updateReceipt Failed", err))
            })
    }
}

// Fetches the appointment-type/amount rows a counselor has configured for
// themselves (id, userId, appointmentType lookupId, amount) — used on the
// register page's Appointment step to only offer types this specific
// counselor actually provides, at their configured price.
export function getUserAppointmentType(userId, success, failure) {
    return function (dispatch, getState) {
        let url = `${getUserAppointmentTypeUrl}?userId=${userId}`
        axiosGet(url)
            .then(response => {
                if (response.data.statusCD === 200) {
                    success(response.data.responseData || [])
                } else {
                    failure(
                        response.data.statusMSG ||
                            "Error while fetching user appointment types"
                    )
                }
            })
            .catch(err => {
                failure(
                    err?.message || "Error while fetching user appointment types"
                )
            })
    }
}
